export default __webpack_public_path__ + "static/media/5.227c246d.mp3";